import { BaseService } from '$lib/api/services/utils/BaseService';
import type {
  HackathonRegistrationResponse,
  MarkSocialImageViewedBody,
  RetrieveHackathonStateResponse,
  RetrieveHallOfFameResponse,
  RetrieveSocialShareableImageQuery,
  RetrieveSocialShareableImageResponse,
} from '$shared/api';

export class HackathonService extends BaseService {
  register(
    fromOnboarding?: boolean,
    country?: string,
    city?: string,
    optOut?: boolean,
  ): Promise<HackathonRegistrationResponse> {
    const body: Record<string, unknown> = {};

    if (fromOnboarding) {
      body.fromOnboarding = fromOnboarding;
    }

    if (country) {
      body.country = country;
    }

    if (city) {
      body.city = city;
    }

    if (optOut) {
      body.optOut = optOut;
    }

    return this.client.send('/api/hackathon/registration', {
      method: 'POST',
      body: Object.keys(body).length > 0 ? body : undefined,
    });
  }

  getState(): Promise<RetrieveHackathonStateResponse> {
    return this.client.send('/api/hackathon/state', {
      method: 'GET',
    });
  }

  getHallOfFame(): Promise<RetrieveHallOfFameResponse> {
    return this.client.send('/api/hackathon/hall-of-fame', {
      method: 'GET',
    });
  }

  getSocialShareableImage(
    query?: RetrieveSocialShareableImageQuery,
  ): Promise<RetrieveSocialShareableImageResponse> {
    return this.client.send('/api/hackathon/social-image', {
      method: 'GET',
      query,
    });
  }

  markSocialImageViewed(body: MarkSocialImageViewedBody): Promise<void> {
    return this.client.send('/api/hackathon/shareable-image-viewed', {
      method: 'POST',
      body,
    });
  }
}
